<template>
    <common-el-form :model="formModel" ref="formModel" :submitData="submitData" @success="onSuccess" :rules="formRules"
                    @cancel="onCancel" submit-btn-text="保存" failTitle="提交失败" loadingText="提交中..."
                    :submitService="submitService" :showButton="false" labelWidth="110px" :handleCheck="true">
        <p class="commonTitle">领袖新星补贴规则设置</p>
        <el-form-item label="用户补贴比例" prop="memPercent">
            <el-input-number v-model="formModel.memPercent" controls-position="right" :precision="2" :step="0.1"
                             :controls="false"
                             :min="0" :max="100"></el-input-number>
            <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="交易类型" prop="tranTypes">
            <el-checkbox-group v-model="formModel.tranTypes">
                <el-checkbox label="1" name="tranTypes">快捷</el-checkbox>
                <el-checkbox label="2" name="tranTypes">还款</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="交易额标准" prop="tranStandard">
            <el-input-number v-model="formModel.tranStandard" controls-position="right" :precision="2" :step="0.1"
                             :controls="false"
                             :min="0" :max="999999999"></el-input-number>
            <span class="unit">元</span>
        </el-form-item>
        <el-form-item label="注册时间" prop="registerDate">
            <el-date-picker
                v-model="formModel.registerDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="机构补贴比例" prop="tatPercent">
            <el-input-number v-model="formModel.tatPercent" controls-position="right" :precision="2" :step="0.1"
                             :controls="false"
                             :min="0" :max="100"></el-input-number>
            <span class="unit">%</span>
        </el-form-item>
        <el-form-item label="有效期" prop="indate">
            <el-input-number v-model="formModel.indate" controls-position="right" :precision="0" :step="1"
                             :controls="false"
                             :min="0" :max="9999999"></el-input-number>
            <span class="unit">天</span>
        </el-form-item>

        <el-form-item label="上级补贴">
            <div class="flex-col vertical-start up-level-box">
                <el-button type="primary" size="small" @click="addLevelItem" style="margin-bottom: 20px">
                    添加
                </el-button>

                <div class="parentRules">
                    <div class="flex-row vertical-center flow-justify up-people-list"
                         v-for="(item, index) in formModel.parentRules" :key="index"
                         style="margin-bottom: 20px">
                        <p class="el-form-item__label">上{{index + 1}}级</p>
                        <el-form-item :prop="'parentRules.' + index + '.levelId'"
                                      :rules="levelRules" style="margin-right: 20px">
                            <el-select v-model="item.levelId" placeholder="请选择">
                                <el-option
                                    v-for="item in levelList"
                                    :key="item.id"
                                    :label="item.levelName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :prop="'parentRules.' + index + '.awardsPercent'"
                                      :rules="percentRules">
                            <el-input-number placeholder="请输入分润金额" :controls="false"
                                             v-model="item.awardsPercent" controls-position="right"
                                             :min="0" :max="100" :precision="2"
                                             :step="0.1"></el-input-number>
                            <p class="unit commonMargin">%</p>
                        </el-form-item>
                        <el-button @click.prevent="removeLevelItem(item)">
                            删除
                        </el-button>
                    </div>
                </div>
            </div>
        </el-form-item>

    </common-el-form>
</template>

<script>
    import CommonElForm from 'components/common/CommonElForm'
    import Regs from "common/conf/Regs";
    import TatMemRewardsService from 'service/TatMemRewardsService'
    import MemberLevelService from 'service/MemberLevelService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, validatorsMixin} from "mixin";
    import StorageService from 'store/interfaces';
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "AddOrganManage",
        props: {
            organInfo: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                formModel: {
                    memPercent: '',
                    tranTypes: [],
                    tranStandard: '',
                    registerDate: '',
                    tatPercent: '',
                    indate: '',
                    parentRules: []
                },
                formRules: {
                    memPercent: [{
                        required: false,
                        validator: (rule, value, callback) => {
                            let upLevel = 0;
                            this.formModel.parentRules.forEach(item => {
                                upLevel = upLevel + Number(item.awardsPercent)
                            });
                            if (upLevel + Number(value) + Number(this.formModel.tatPercent) > 100) {
                                return callback(new Error('补贴比例总和不能大于100%'))
                            }
                            callback()
                        },
                        trigger: ['blur', 'change']
                    }],
                    tatPercent: [{
                        required: false,
                        validator: (rule, value, callback) => {
                            let upLevel = 0;
                            this.formModel.parentRules.forEach(item => {
                                upLevel = upLevel + Number(item.awardsPercent)
                            });
                            if (upLevel + Number(value) + Number(this.formModel.memPercent) > 100) {
                                return callback(new Error('补贴比例总和不能大于100%'))
                            }
                            callback()
                        },
                        trigger: ['blur', 'change']
                    }],
                    tranTypes:[{
                        type: 'array',
                        required: true,
                        message: '请选择交易类型',
                        trigger: ['blur', 'change']
                    }],
                    registerDate:[{
                        required: true,
                        message: '请选择注册时间',
                        trigger:  'change'
                    }],
                    indate: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入有效期'))
                            } else {
                                callback()
                            }
                        },
                        trigger: ['blur', 'change']
                    }],
                },

                levelRules: {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            return callback(new Error('请选择会员等级'))
                        }
                        return callback();
                    },
                },
                percentRules: [{
                    required: false,
                    validator: (rule, value, callback) => {
                        let upLevel = 0;
                        this.formModel.parentRules.forEach(item => {
                            upLevel = upLevel + Number(item.awardsPercent)
                        });
                        if (upLevel + Number(this.formModel.tatPercent) + Number(this.formModel.memPercent) > 100) {
                            return callback(new Error('补贴比例总和不能大于100%'))
                        }
                        callback()
                    },
                    trigger: ['blur', 'change']
                }],
                levelList: []
            }
        },
        mixins: [loadMixin, validatorsMixin],
        components: {
            CommonElForm
        },
        mounted() {
            this.getLevelList();
            this.getInfo();
        },
        computed: {
            submitService(){
                if (this.formModel.id) {
                    return TatMemRewardsService.tatMemRewardsRuleEdit
                }
                return TatMemRewardsService.tatMemRewardsRuleAdd
            },
            submitData() {
                const params = {
                    simpleTatId: this.organInfo.id,
                    memPercent: this.formModel.memPercent,
                    tranTypes: this.formModel.tranTypes.toString(),
                    tranStandard: this.formModel.tranStandard,
                    registerDate: this.formModel.registerDate,
                    tatPercent: this.formModel.tatPercent,
                    indate: this.formModel.indate,
                    parentRuleJson: JSON.stringify(this.formModel.parentRules)
                };
                if (this.formModel.id) {
                    params.id = this.formModel.id
                }
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            getLevelList() {
                this.doLoad(MemberLevelService.select, {
                    tatSimpleId: this.organInfo.id
                }, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.levelList = result.memLevelManageList;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.$emit('onSuccess', res)
                this.getInfo();
            },
            onCancel() {
                this.$emit('onCancel')
            },
            getInfo() {
                this.doLoad(TatMemRewardsService.tatMemRewardsRuleDetail, {
                    simpleTatId: this.organInfo.id,
                    userId: this.userId,
                }, res => {
                    this.doCheck(res, res => {
                        let result = res.contents;
                        if (result) {
                            this.formModel = result;
                            if (!this.formModel.parentRules) {
                                this.formModel.parentRules = []
                            }
                            this.formModel.registerDate = this.formModel.registerDate;
                            this.formModel.tranTypes = this.formModel.tranTypes ? this.formModel.tranTypes.split(',') : [];

                            this.$nextTick(()=>{

                                this.$refs.formModel.handleValid();
                            })
                        }
                    });
                }, '信息获取失败')
            },
            addLevelItem() {
                this.formModel.parentRules.push({
                    awardsPercent: '',
                    levelId: '',
                    parentIndex: this.formModel.parentRules.length + 1,
                });
            },
            removeLevelItem(item) {
                this.showConfirm('确定要删除此层级吗？').then(() => {
                    let index = this.formModel.parentRules.indexOf(item);
                    if (index !== -1) {
                        this.formModel.parentRules.splice(index, 1)
                    }
                }).catch(() => {
                });
            },
            ...mapActions({
                isReloadPage: StorageService.Reload.page,
            })
        }
    }
</script>

<style scoped>
    .parentRules {
        display: flex;
        flex-wrap: wrap;
    }

    .unit {
        margin-left: 10px;
        color: #aaaaaa;
        word-break: keep-all;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/OrganManage/NewRewardRules.vue